import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import SearchFilterTable from '../../microComponents/tablePages/filter/SearchFilterTable';
import UseSetParams from '../../microComponents/tablePages/filter/UseSetParams';
import SelectFilterTable from '../../microComponents/tablePages/filter/SelectFilterTable';
import ConfirmModal from "./ConfirmModal";
import {levelList} from "../../helper/jsons/levelList";
import {getFilterTypeNotif} from "../../microComponents/tablePages/getFilterTypeNotif";
import SearchFilterTableNumber from "../../microComponents/tablePages/filter/SearchFilterTableNumber";
import {getFilterLocation} from "../../microComponents/tablePages/getFilterLocation";
import DateFilterTable from "../../microComponents/tablePages/filter/DateFilterTable";
import {isWithdraw} from "../../helper/jsons/isWithdraw";

const NotificationColumn = () => {
    const filter = useSelector((state) => state.TableRedux.filter);
    const [getColumnSearchProps] = SearchFilterTable();
    const [handleSetParams] = UseSetParams();
    const [getColumnDateProps,] = DateFilterTable()

    const [getColumnSelectProps] = SelectFilterTable();
    const [typeNotifList, setTypeNotifList] = useState([])
    const [typeNotifListLoading, setTypeNotifListLoading] = useState(false)
    const [getColumnSearchPropsNumber] = SearchFilterTableNumber();
    const [filterLocation, setFilterLocation] = useState([]);
    const [locationLoading, setLocationLoading] = useState(false);
    const funcHandleSetParams = (newFilter) => {
        handleSetParams(newFilter);
    };

    const handleGetFilterLocation = () => {

        getFilterLocation(setFilterLocation, setLocationLoading)
    }

    const handleGetTypes = () => {


        getFilterTypeNotif(setTypeNotifList, setTypeNotifListLoading)
    }


    const columns = [{
        title: 'ردیف', dataIndex: 'row', key: 'row', render: (text, row, index) => {
            return index + 1;
        },
    },
        {
            title: 'درجه اهمیت',
            dataIndex: 'level',
            key: 'level', ...getColumnSelectProps(filter.level, 'level', 'درجه اهمیت', levelList, null, (res) => {
                funcHandleSetParams([{key: 'level', value: res}]);
            }, false, 'single'),
        },
        {
            title: 'نوع',
            dataIndex: 'type',
            key: 'type', ...getColumnSelectProps(filter.type, 'type', 'نوع', typeNotifList, handleGetTypes, (res) => {
                funcHandleSetParams([{key: 'type', value: res}]);
            }, typeNotifListLoading),
        }, {
            title: 'شماره اموال',
            dataIndex: 'palletId',
            key: 'palletId', ...getColumnSearchPropsNumber('شناسه پالت', filter.palletId, (res) => {
                funcHandleSetParams([{key: 'palletId', value: res}]);
            }, 16, 'palletId'),
        }, {
            title: 'توسط',
            dataIndex: 'by',
            key: 'by', ...getColumnSearchProps('توسط', filter.by, (res) => {
                funcHandleSetParams([{key: 'by', value: res}]);
            }, 'by'),
        }, {
            title: 'موقعیت',
            dataIndex: 'location',
            key: 'location', ...getColumnSelectProps(filter.locations, 'locations', 'موقعیت', filterLocation, handleGetFilterLocation, (res) => {
                funcHandleSetParams([{key: 'locations', value: res}]);
            }, locationLoading),
        },


        {
            title: 'زمان',
            dataIndex: 'time',
            key: 'time',
            className: "hidden lg:table-cell",

            ...getColumnDateProps([filter.fromTime, filter.toTime], (res) => {

                funcHandleSetParams([{key: 'fromTime', value: res.from_date}, {
                    key: 'toTime', value: res.end_date
                }])
            }, 'time'),
        },


        {
            title: 'وضعیت',
            dataIndex: 'isWithdraw',
            key: 'isWithdraw', ...getColumnSelectProps(filter.isWithdraw, 'isWithdraw', 'وضعیت', isWithdraw, null, (res) => {
                funcHandleSetParams([{key: 'isWithdraw', value: res}]);
            }, false, 'single'),
            render: (item, row) => {
                return <>{!row.isWithdraw
                    && <ConfirmModal data={row}/>}</>
            }

        },


        // {
        //     title: 'وضعیت',
        //     dataIndex: 'status',
        //     key: 'status', ...getColumnSearchProps('وضعیت', filter.status, (res) => {
        //         funcHandleSetParams([{key: 'status', value: res}]);
        //     }, 'status'),
        //
        // },


    ];
    return [columns];
};

export default NotificationColumn;